import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useFeedback } from '../context/FeedbackContext';
import useGiftSetSettings from '../hooks/useGiftSetSettings';
import GiftSetMembersSection from './giftSet/GiftSetMembersSection';
import GiftSetNameForm from './giftSet/GiftSetNameForm';
import GiftSetPairingPanel from './giftSet/GiftSetPairingPanel';
import GiftSetSettingsHeader from './giftSet/GiftSetSettingsHeader';

const GiftSetSettingsModal = ({
  isOpen,
  ownerUuid,
  onClose,
  theme,
}) => {
  const feedback = useFeedback();
  const giftSet = useGiftSetSettings({feedback, isOpen, ownerUuid});

  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <div
        className="fixed inset-0 z-[6000] flex items-center justify-center bg-[#211B1D]/60 p-5 backdrop-blur-md"
        onMouseDown={(event) => event.stopPropagation()}
        onTouchStart={(event) => event.stopPropagation()}
      >
        <motion.div
          initial={{ opacity: 0, y: 22, scale: 0.96 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 18, scale: 0.96 }}
          className="lumirae-ds-panel flex max-h-[92dvh] w-full max-w-lg flex-col p-4 shadow-2xl sm:p-5"
          style={{
            '--lumirae-accent-primary': theme.accent,
            '--lumirae-accent-soft': theme.accentSoft,
            '--lumirae-surface-raised': theme.cardBg,
            '--lumirae-border-default': theme.cardBorder,
            '--lumirae-text-primary': theme.text,
            '--lumirae-text-secondary': theme.secondaryText,
          }}
        >
          <GiftSetSettingsHeader onClose={onClose} theme={theme} />

          <div className="mt-3 min-h-0 flex-1 overflow-y-auto pr-1">
            <GiftSetNameForm
              error={giftSet.error}
              groupName={giftSet.groupName}
              isPairing={giftSet.isPairing}
              isSavingName={giftSet.isSavingName}
              onChange={giftSet.setGroupName}
              onSave={giftSet.saveName}
              theme={theme}
            />

            <GiftSetPairingPanel
              isPairing={giftSet.isPairing}
              ownerUuid={ownerUuid}
              pendingBind={giftSet.pendingBind}
              onAddMemberFromUrl={giftSet.addMemberFromUrl}
              onStartPairing={giftSet.startPairing}
              onStopPairing={giftSet.stopPairing}
              theme={theme}
            />

            <GiftSetMembersSection
              group={giftSet.group}
              isLoading={giftSet.isLoading}
              memberRows={giftSet.memberRows}
              onRemoveMember={giftSet.removeMember}
              ownerMember={giftSet.ownerMember}
              theme={theme}
            />
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default GiftSetSettingsModal;
